import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
import HighPriority from '../../static/images/questpriority/high-priority.svg'
import MediumPriority from '../../static/images/questpriority/medium-priority.svg'

const Icon = styled.div`
  background: ${props =>
      props.priority === 'high'
        ? `url(${HighPriority})`
        : `url(${MediumPriority})`}
    no-repeat;
  width: ${props => (props.small ? '8px' : '11px')};
  height: ${props => (props.small ? '14px' : '19px')};
  background-size: 100%;
`

const PriorityIndicator = props => {
  const tooltipId = `quest-${props.questId}-priority`
  return (
    <React.Fragment>
      <ReactTooltip id={tooltipId} effect="solid" />
      <Icon
        small={props.small}
        priority={props.priority}
        data-tip={`${props.priority === 'high' ? 'High' : 'Medium'} Priority`}
        data-for={tooltipId}
      />
    </React.Fragment>
  )
}

PriorityIndicator.propTypes = {
  priority: PropTypes.string.isRequired,
  questId: PropTypes.number.isRequired,
  small: PropTypes.bool
}

export default PriorityIndicator



// WEBPACK FOOTER //
// ./src/components/mini/PriorityIndicator.js